// extracted by mini-css-extract-plugin
export default {"title":"LangSwitch_title__5t24e","language":"LangSwitch_language__ZBm77","flagBox":"LangSwitch_flagBox__DXxjB","fill":"LangSwitch_fill__ccM0s","flag":"LangSwitch_flag__sPzI+"};